export const hotkey_keyword_shift = "uWb";
export const hotkey_keyword_ctrl = "vWb";
export const hotkey_keyword_alt = "wWb";
export const hotkey_keyword_meta = "xWb";
export const hotkey_keyword_backspace = "yWb";
export const hotkey_keyword_tab = "zWb";
export const hotkey_keyword_enter = "AWb";
export const hotkey_keyword_return = "BWb";
export const hotkey_keyword_capslock = "CWb";
export const hotkey_keyword_esc = "DWb";
export const hotkey_keyword_escape = "EWb";
export const hotkey_keyword_space = "FWb";
export const hotkey_keyword_pageup = "GWb";
export const hotkey_keyword_pagedown = "HWb";
export const hotkey_keyword_end = "IWb";
export const hotkey_keyword_home = "JWb";
export const hotkey_keyword_left = "KWb";
export const hotkey_keyword_up = "LWb";
export const hotkey_keyword_right = "MWb";
export const hotkey_keyword_down = "NWb";
export const hotkey_keyword_ins = "OWb";
export const hotkey_keyword_del = "PWb";
export const hotkey_keyword_command = "QWb";
export const hotkey_keyword_plus = "RWb";
export const keyboardShortcutThen = "SWb";
export default {hotkey_keyword_shift,hotkey_keyword_ctrl,hotkey_keyword_alt,hotkey_keyword_meta,hotkey_keyword_backspace,hotkey_keyword_tab,hotkey_keyword_enter,hotkey_keyword_return,hotkey_keyword_capslock,hotkey_keyword_esc,hotkey_keyword_escape,hotkey_keyword_space,hotkey_keyword_pageup,hotkey_keyword_pagedown,hotkey_keyword_end,hotkey_keyword_home,hotkey_keyword_left,hotkey_keyword_up,hotkey_keyword_right,hotkey_keyword_down,hotkey_keyword_ins,hotkey_keyword_del,hotkey_keyword_command,hotkey_keyword_plus,keyboardShortcutThen};